import Http from '@/api/http.js'

export default {
  indexReversal(filter){
    return Http.get(`clients/${client_id}/reversals`, {
      headers: {
        filter: JSON.stringify(filter? filter : null)
      }
    });
  },
  createReversal(new_reversal){
    const {ammount, comment, due_date, place_id, solution, payment_description} = new_reversal
    return Http.post(`clients/${new_reversal.client_id}/financial/reversals`, {
      reversal:{
        ammount: Number(ammount),
        comment,
        due_date,
        place_id, 
        solution,
        payment_description
      }
    })

  },
}